import { render, staticRenderFns } from "./OrderPuesc.vue?vue&type=template&id=4d734d58&"
import script from "./OrderPuesc.vue?vue&type=script&lang=js&"
export * from "./OrderPuesc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports